module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "step5-form",
    style: ({
      minHeight: (_vm.screenHeight - 85) + 'px'
    })
  }, [_c('div', {
    staticClass: "step-form__step-num"
  }, [_vm._v("5/5")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-form__main"
  }, [_c('h1', {
    staticClass: "step-form__title"
  }, [_vm._v("提交成功")]), _vm._v(" "), _c('div', {
    staticClass: "step5-form__form"
  }, [_c('div', {
    staticClass: "step5-form__success-message"
  }, [_vm._v("资料提交成功，请等待审核")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c470782"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLoan/Step5_bak.vue
// module id = 1079
// module chunks = 1